module.exports = __webpack_public_path__ + "static/media/85.c50631e4.jpg";